/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-duplicate-props */
import { useEffect, useRef, useState } from "react";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import FreightDetails from "./FreightDetails";
import ICompAnalysis from "../../../types/ICompAnalysis";
import "./CAOffer.css";
import { useNitroStore } from "../../../store/Store";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";
import FreightBox from "./FreightBox";
import convertRailFreightDetailData from "../../../utils/convertRailFreightDetailData";
import { IPinExtension } from "../../../types/ILocation";

const green = "#C0FFBD";
const yellow = "#FFFF83";
const red = "#FE8686A3";
const gray = "#ECEDEF";

const CAOfferExists = ({
  record,
  selectedLocation,
}: {
  record: ICompAnalysis;
  selectedLocation: IPinExtension;
}) => {
  const [
    setRouteValidationOpen,
    displayFreightDetailsPanel,
    setSelectedRailDetailRecord,
    setDisplayFreightDetailsPanel,
    setSelectYourOfferFreight,
    kochOffer,
    setKochOffer,
  ] = useNitroCAStore((state) => [
    state.setRouteValidationOpen,
    state.displayRailFreightDetailsPanel,
    state.setSelectedRailDetailRecord,
    state.setDisplayRailFreightDetailsPanel,
    state.setSelectYourOfferFreight,
    state.kochOffer,
    state.setKochOffer,
  ]);

  const [freightDetailsOpen, setFreightDetailsOpen] = useState<boolean>(false);
  useEffect(() => {
    if (!record) return setFreightDetailsOpen(false);
    setFreightDetailsOpen(false);
  }, [record]);

  const toggleFreightDetails = () => {
    setFreightDetailsOpen(!freightDetailsOpen);
  };

  const toggleFreightDetailPanel = () => {
    const railFreightDetailData = convertRailFreightDetailData({
      ...record,
    });
    setSelectedRailDetailRecord(railFreightDetailData);
    if (!displayFreightDetailsPanel) {
      setDisplayFreightDetailsPanel(!displayFreightDetailsPanel);
    } else {
      setSelectYourOfferFreight(true);
    }
  };
  const [offer, setOffer] = useState(record.initialOffer);
  const [netback, setNetback] = useState(record.price);
  // when favorite origins are updated and comp analysis is reloaded then reset offer and netback
  useEffect(() => {
    setOffer(record.initialOffer);
    setNetback(record.price);
  }, [record]);

  const [width, setWidth] = useState(100);
  useEffect(() => {
    const newWidth = (String(offer).split(".")[0].length + 1) * 15;
    setWidth(Math.max(newWidth, 40));
  }, [offer]);
  const [netbackOld, setNetbackOld] = useState(
    Math.round((kochOffer ?? 0) - (record.freight || 0)),
  );
  useEffect(() => {
    setNetbackOld(Math.round((kochOffer ?? 0) - (record.freight || 0)));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record]);

  const offerRef = useRef<any>();

  const [color, setColor] = useState("#ECEDEF");
  useEffect(() => {
    if (!record) {
      setNetback(0);
      return;
    }
    const minPrice = record.minPrice || record.maxPrice;
    if (record.maxPrice) {
      if (netback > record.maxPrice) {
        setColor(green);
      } else if (netback === record.maxPrice) {
        setColor(gray);
      } else if (netback >= minPrice) {
        console.log("yellow netback", netback, minPrice, netbackOld);
        setColor(yellow);
      } else {
        setColor(red);
      }
    } else {
      setColor(gray);
    }
  }, [offer, netback, record, netbackOld]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ fontSize: 18, fontWeight: 500, paddingLeft: 10 }}>
          Your Offer
        </div>
        <Tooltip title="Click to troubleshoot why you are not getting guidance from a particular origin">
          <Button
            id="troubleshootCARouteButton"
            color="error"
            onClick={() => {
              if (!selectedLocation) return;
              setRouteValidationOpen(true);
            }}
          >
            Missing an Origin?
          </Button>
        </Tooltip>
      </div>
      <Paper
        style={{
          backgroundColor: "white",
          padding: "15px 10px",
          display: "flex",
          flexDirection: "column",
          gap: 5,
          borderRadius: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            className="LocationBubble"
            style={{
              fontWeight: 400,
              color: "#4b4b4b",
              textAlign: "center",
            }}
          >
            Destination:
          </div>

          <div
            className="LocationBubble"
            style={{
              fontWeight: 400,
              color: "#4b4b4b",
              textAlign: "center",
            }}
          >
            Origin:
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Koch Offer */}
          <div
            className="LocationBubble"
            style={{
              height: 65,
              borderRadius: 33,
              backgroundColor: "#ECEDEF",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: 25,
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div>$</div>
              <TextField
                inputRef={offerRef}
                size="small"
                variant="standard"
                value={Math.round(offer)}
                style={{
                  width,
                }}
                onChange={(e: any) => {
                  let stringVal = String(e.target.value).replaceAll(",", "");
                  if (["-", "-0"].indexOf(stringVal) > -1) {
                    setOffer(Number(stringVal));
                    setNetback(0);
                    setNetbackOld(0);
                    return;
                  }

                  const num = Number(stringVal);
                  if (Number.isNaN(num)) {
                    return;
                  }
                  if (num > 9999 || num < -9999) {
                    return;
                  }

                  if (stringVal.startsWith("0") && stringVal.length > 1) {
                    stringVal = stringVal.slice(1, stringVal.length);
                  }
                  const split = stringVal.split(".");
                  const val = Number(split[0]);
                  setOffer(val);
                  setNetback(Math.round(val - (record?.freight || 0)));
                  setKochOffer(val);
                }}
                inputProps={{
                  style: {
                    padding: 0,
                    fontSize: 25,
                  },
                }}
                InputProps={{
                  style: {
                    backgroundColor: "#ECEDEF",
                  },
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      style={{ padding: 0, margin: 0, width: 0 }}
                    />
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ padding: 0, margin: 0, width: 0 }}
                    />
                  ),
                }}
              />
            </div>
            <div
              style={{
                maxHeight: 4,
                fontSize: 11,
                color: "#383838",
              }}
            >
              Offer
            </div>
          </div>

          <div style={{ height: 3, backgroundColor: "#D9D9D9", flexGrow: 1 }} />

          {/* Freight */}
          <Tooltip
            title={record.freight ? "Click to view Freight Details" : undefined}
            placement="bottom"
          >
            <div>
              <FreightBox
                record={record}
                toggleFreightDetails={toggleFreightDetails}
                toggleFreightDetailPanel={toggleFreightDetailPanel}
              />
            </div>
          </Tooltip>

          <div style={{ height: 3, backgroundColor: "#D9D9D9", flexGrow: 1 }} />

          {/* Netback */}
          <div
            className="LocationBubble"
            style={{
              height: 65,
              borderRadius: 33,
              backgroundColor: color,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                fontSize: 25,
                fontWeight: 400,
                display: "flex",
                alignItems: "center",
              }}
            >
              <div>$</div>
              <TextField
                inputRef={offerRef}
                size="small"
                variant="standard"
                value={netback.toLocaleString()}
                style={{
                  width,
                }}
                onChange={(e: any) => {
                  let stringVal = String(e.target.value).replaceAll(",", "");
                  if (["-", "-0"].indexOf(stringVal) > -1) {
                    setOffer(record.freight * -1);
                    setNetback(stringVal as any);
                    setNetbackOld(stringVal as any);
                    return;
                  }

                  const num = Number(stringVal);
                  if (Number.isNaN(num)) {
                    return;
                  }
                  if (num > 9999 || num < -9999) {
                    return;
                  }

                  if (stringVal.startsWith("0") && stringVal.length > 1) {
                    stringVal = stringVal.slice(1, stringVal.length);
                  }
                  const split = stringVal.split(".");
                  const val = Number(split[0]);

                  const newKochOffer = Math.round(val + record.freight);
                  setOffer(newKochOffer);
                  setNetback(val);
                  setNetbackOld(val);
                }}
                inputProps={{
                  style: {
                    padding: 0,
                    fontSize: 25,
                  },
                }}
                InputProps={{
                  style: {
                    backgroundColor: color,
                  },
                  startAdornment: (
                    <InputAdornment
                      position="start"
                      style={{ padding: 0, margin: 0, width: 0 }}
                    />
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      style={{ padding: 0, margin: 0, width: 0 }}
                    />
                  ),
                }}
              />
            </div>
            <div
              style={{
                maxHeight: 4,
                fontSize: 11,
                color: "#383838",
              }}
            >
              FOB
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            className="LocationBubble"
            style={{
              fontWeight: 400,
              color: "#4b4b4b",
              textAlign: "center",
            }}
          >
            {record?.destination.name}
          </div>

          <div
            style={{
              width: 130,
              fontSize: 14,
              fontWeight: 400,
              color: "#4b4b4b",
              textAlign: "center",
            }}
          >
            {record?.origin.name}
          </div>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {record.maxPrice && (
            <div>
              <div
                style={{
                  textAlign: "center",
                  fontSize: 15,
                  fontWeight: 500,
                  marginBottom: "5px",
                  color: "#4b4b4b",
                }}
              >
                Netback Guidance
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 0 }}>
                <div
                  style={{ fontSize: 16, fontWeight: 400, color: "#4b4b4b" }}
                >
                  {` $${record?.maxPrice || 0} FOB - $${
                    record?.minPrice || record.maxPrice
                  } ALT`}
                </div>
              </div>
            </div>
          )}

          {(!record.maxPrice || !record.maxPrice) && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 4,
              }}
            >
              <div
                style={{
                  fontWeight: 500,
                  fontSize: 16,
                  color: "#4b4b4b",
                  fontStyle: "italic",
                }}
              >
                No Product Guidance
              </div>
            </div>
          )}
        </div>
      </Paper>

      {freightDetailsOpen && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "0px 6px",
          }}
        >
          <Paper
            style={{
              width: "100%",
              padding: "12px 6px",
              borderRadius: 10,
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <FreightDetails
              record={record}
              close={() => {
                setFreightDetailsOpen(false);
              }}
            />
          </Paper>
        </div>
      )}
    </div>
  );
};

const CAOffer = ({
  record,
  selectedLocation,
}: {
  record?: ICompAnalysis;
  selectedLocation: IPinExtension;
}) => {
  const [setRouteValidationOpen] = useNitroCAStore((state) => [
    state.setRouteValidationOpen,
  ]);
  const [mode, setShowAddLocationPanel] = useNitroStore((state) => [
    state.mode,
    state.setShowAddLocationPanel,
  ]);

  if (!record)
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <div style={{ fontSize: 18, fontWeight: 500, paddingLeft: 10 }}>
          Your Offer
        </div>
        <Paper
          style={{
            padding: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 20,
            borderRadius: 10,
          }}
        >
          {selectedLocation.pinType === "zipCodes" && mode === "RAIL" && (
            <>
              <div
                style={{
                  fontSize: 16,
                  fontWeight: 400,
                  fontStyle: "italic",
                  color: "#4b4b4b",
                }}
              >
                Unable to return RAIL freight guidance to zip codes.
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <div style={{ textAlign: "center" }}>
                  Check if the location you&apos;re looking for is already
                  added. If not, add it.
                </div>

                <Button
                  id="addLocationFromCAButton"
                  onClick={() => setShowAddLocationPanel(true)}
                  variant="outlined"
                  style={{ width: 200 }}
                >
                  Add Location
                </Button>
              </div>
            </>
          )}

          {(!(selectedLocation?.pinType === "zipCodes" && mode === "RAIL") ||
            !record) && (
            <div
              style={{
                fontSize: 16,
                fontWeight: 400,
                fontStyle: "italic",
                color: "#4b4b4b",
                textAlign: "center",
              }}
            >
              Dang! Did you forget to add a Koch origin
              <br />
              above the search bar?
              <br />
              <br />
              If you&apos;ve added at least one Koch origin and enabled the mode
              you want to quote,
              <br />
              click the button below.
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "center" }}>
            <Button
              id="troubleshootCA2Button"
              variant="contained"
              color="error"
              onClick={() => {
                setRouteValidationOpen(true);
              }}
            >
              Troubleshoot
            </Button>
          </div>
        </Paper>
      </div>
    );

  return <CAOfferExists record={record} selectedLocation={selectedLocation} />;
};

export default CAOffer;
